/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsslSearchRequestBody } from '|api/commons';
import { PageWorkflowTriggerEventProcessDto } from '../../models/page-workflow-trigger-event-process-dto';

export interface AutomatedProcessSearchTriggerEventProcesses$Params {
  
    /**
     * Search API request body.
     */
    body?: EsslSearchRequestBody|null|undefined
}

export function automatedProcessSearchTriggerEventProcesses(http: HttpClient, rootUrl: string, params?: AutomatedProcessSearchTriggerEventProcesses$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<PageWorkflowTriggerEventProcessDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessSearchTriggerEventProcesses.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageWorkflowTriggerEventProcessDto>;
    })
  );
}

automatedProcessSearchTriggerEventProcesses.PATH = '/automated-process/workflow-trigger/trigger-event-process/search-api';